import { Link } from "react-router-dom";

export function CarsUnder30kCta() {
  return (
    <section className="py-16 bg-[#1A2332] text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="font-oswald text-4xl font-bold mb-4">
          Find Your Perfect Car Under $30k
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Browse our selection of quality vehicles that fit your budget. 
          Apply for financing in minutes and drive home today.
        </p>

        <div className="flex flex-wrap justify-center gap-4">
          <Link
            to="/inventory"
            className="inline-flex items-center gap-2 bg-[#E8B84B] text-[#1A2332] px-8 py-4 rounded-lg font-semibold hover:bg-[#D4A43A] transition-colors whitespace-nowrap"
          >
            <i className="ri-car-line text-xl"></i>
            View Inventory
          </Link>
          <Link
            to="/apply-for-financing"
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/30 px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            <i className="ri-calculator-line text-xl"></i>
            Apply for Financing
          </Link>
        </div>
      </div>
    </section>
  );
}
